<template>
  <div class="FinancesInvoicesCompanyItemsTable finances-invoices-table">
    <b-table :fields="fields" :items="items" class="mb-0">
      <template #cell(user)="{ item, index }">
        <multiselect
          class="multiselect-small-line-height"
          v-model="item.user"
          @input="dataTouched(index, 'user')"
          placeholder="Employee"
          :options="getUsersForSelect"
          track-by="id"
          label="label"
          return="id"
          :showLabels="false"
          allow-empty
        ></multiselect>
      </template>
      <template #cell(hour_cost)="{ item, index }">
        <b-form-input
          type="number"
          no-wheel
          v-model="item.hour_cost"
          @input="dataTouched(index, 'hour_cost')"
        />
      </template>
      <template #cell(hours_amount)="{ item, index }">
        <b-form-input
          type="number"
          step="0.01"
          no-wheel
          v-model="item.hours_amount"
          @input="dataTouched(index, 'hours_amount')"
        />
        <span
          class="cursor-pointer hours-info"
          v-b-tooltip.hover="{ variant: 'base' }"
          :title="hoursTooltip(item)"
        >
          <div
            v-if="item.hoursCalculating"
            class="hours-loader spinner-border text-secondary"
            role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <font-awesome-icon
            v-else-if="hoursTooltip(item)"
            icon="info"
            class="hours-info-label"
          />
        </span>
      </template>
      <template #cell(calculateHours)="{ item, index }">
        <b-form-checkbox
          type="checkbox"
          size="lg"
          v-model="item.calculateHours"
          @input="dataTouched(index, 'auto_hours_amount', $event)"
          :value="true"
          title="Auto calculate hours from worklogs and v&s google doc"
        />
      </template>
      <template #cell(date_from)="{ item, index }">
        <b-form-group
          style="position: relative;">
          <!-- TODO NEED UPDATE VUE BOOTSTRAP AND REMOVE CURRENT DATAPICKER, INPUT -->
          <b-form-input
            style="position: absolute;"
            :value="convertDataToString(item.date_from)"
            required
          />
          <Datepicker
            :bootstrap-styling="true"
            :value="_toIsoStringTime(item.date_from)"
            @input="item.date_from = _toLocalTime($event); dataTouched(index, 'date_from')"
            format="yyyy-MM-dd"
          />
        </b-form-group>
      </template>
      <template #cell(date_to)="{ item, index }">
        <b-form-group
          style="position: relative;">
          <!-- TODO NEED UPDATE VUE BOOTSTRAP AND REMOVE CURRENT DATAPICKER, INPUT -->
          <b-form-input
            style="position: absolute;"
            :value="convertDataToString(item.date_to)"
            required
          />
          <Datepicker
            :bootstrap-styling="true"
            :value="_toIsoStringTime(item.date_to)"
            @input="item.date_to = _toLocalTime($event); dataTouched(index, 'date_to')"
            format="yyyy-MM-dd"
          />
        </b-form-group>
      </template>
      <template #cell(commission)="{ item, index }">
        <b-form-input
          type="number"
          no-wheel
          v-model="item.commission"
          @input="dataTouched(index, 'commission')"
        />
      </template>
      <template #cell(actions)="data" v-if="items.length > 1">
       <b-button variant="danger" size="sm" @click.prevent="removeItem(data)">
         <font-awesome-icon icon="trash" />
       </b-button>
      </template>
    </b-table>
    <b-button @click.prevent="addItem" variant="info">
      Add item
    </b-button>
  </div>
</template>

<script>
import FormItemsMixin from '../../mixins/FormItemsMixin'

export default {
  mixins: [FormItemsMixin],
  data () {
    return {
      fields: [
        { key: 'user', label: 'Employee', class: 'employee-column' },
        { key: 'hour_cost', label: 'Hourly rate', class: 'cost-column' },
        { key: 'hours_amount', label: 'Hours', class: 'hours-column' },
        { key: 'calculateHours', label: 'Auto', class: 'calculate-hours-column' },
        { key: 'date_from', label: 'Date from', class: 'date-from-column date-column' },
        { key: 'date_to', label: 'Date to', class: 'date-to-column date-column' },
        { key: 'commission', label: 'Commission', class: 'commission-column' },
        { key: 'actions', label: '', class: 'actions-column' }
      ],
      items: [],
      defaultItem: {
        'user': null,
        'hours_amount': 0,
        'hour_cost': 0,
        'date_from': null,
        'date_to': null,
        'commission': null,
        'calculateHours': true,
        'hoursCalculating': false
      }
    }
  }
}
</script>

<style lang="scss">
  .finances-invoices-table{
    margin-bottom: 1rem;
    .table th,
    .table td {
      padding: 12px 6px;
    }
    .item-type-column{
      min-width: 200px;
    }
    .employee-column {
      min-width: 190px;
    }
    .hours-column,
    .cost-column {
      min-width: 63px;
    }
    .calculate-hours-column {
      min-width: 20px;
      max-width: 35px;
    }
    .commission-column {
      min-width: 50px;
      max-width: 70px;
    }
    .actions-column {
      min-width: 20px;
      max-width: 40px;
    }
    .date-column {
      min-width: 100px;
    }
    .hours-info{
      position:absolute;
      margin-left:60px;
      margin-top:-27px;
    }
    .hours-info-label {
      font-size:0.7rem;
      margin-left:5px;
      margin-bottom:2px;
    }
    .hours-loader{
      width:1rem;
      height:1rem;
      margin-left:-3px;
    }
  }
</style>
